import React, { useEffect, useState } from "react";

export const triggerSaveStatus = (status: "saving" | "saved") => {
  window.dispatchEvent(
    new CustomEvent("excalidraw-save-status", { detail: status }),
  );
};

export const SaveIndicator = () => {
  const [status, setStatus] = useState<"saving" | "saved" | "hidden">("hidden");

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const handleStatus = (e: any) => {
      const newStatus = e.detail;
      setStatus(newStatus);
      clearTimeout(timeout);
      if (newStatus === "saved") {
        timeout = setTimeout(() => {
          setStatus("hidden");
        }, 2000);
      }
    };
    window.addEventListener("excalidraw-save-status", handleStatus);
    return () => {
      window.removeEventListener("excalidraw-save-status", handleStatus);
      clearTimeout(timeout);
    };
  }, []);

  if (status === "hidden") return null;

  return (
    <div
      style={{
        position: "absolute",
        bottom: "20px",
        right: "20px",
        transform: "none",
        padding: "6px 14px",
        background: status === "saving" ? "#FFC107" : "#4CAF50",
        color: status === "saving" ? "#000" : "#fff",
        borderRadius: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        fontSize: "13px",
        fontWeight: "bold",
        pointerEvents: "none",
        zIndex: 999999,
        transition: "opacity 0.3s ease",
        display: "flex",
        alignItems: "center",
        gap: "6px"
      }}
    >
      {status === "saving" ? (
        <>
          <span style={{ animation: "pulse 1s infinite" }}>⏳</span> Saving...
        </>
      ) : (
        <>
          <span>✅</span> Saved!
        </>
      )}
    </div>
  );
};
